import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import AuthModal from "./AuthModal";
import ProfileForm from "./ProfileForm";
import { SigninContainer } from "./styles";

export const ProfileModal = ({ open, initialProfile, onClose, onSuccess }) => {
  const [success, setSuccess] = useState(false);

  return (
    <AuthModal open={open} onClose={onClose} graphic="none">
      <SigninContainer>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "20px",
            top: "20px",
            // Above .form-root so the click isn't swallowed by the
            // sibling Box that visually sits behind it but comes later
            // in the DOM (same default z-index → later wins hit-test).
            zIndex: 1,
            backgroundColor: "transparent",
            color: "#8C8C8C",
            padding: "4px",
            "&:hover": {
              backgroundColor: "transparent",
              color: "#5C5C5C",
            },
          }}
        >
          <CloseIcon sx={{ width: "24px", height: "24px" }} />
        </IconButton>
        <Box
          className="form-root signup"
          style={success ? { display: "flex" } : {}}
        >
          <div>
            <img src={'/images/mattoboard-logo.jpg'} alt="MattoBoard" className="logo-img" />
            <ProfileForm
              initialProfile={initialProfile}
              onSuccess={() => {}}
            />
          </div>
        </Box>
      </SigninContainer>
    </AuthModal>
  );
};

export default ProfileModal;
